<template>
<div class="login-page">
	
	<div class="login">
		<div class="login-bottom">
			<img src="@/assets/logo.png" alt="" class="logo mb-4">
			<h3>Ingresar</h3>
			<p>Ingresá a tu cuenta con tu usuario y contraseña</p>
			<form @submit.prevent="login" class="mt-4">
				<div class="row">
					<div class="col-12">
						<div class="form-group ">
							<label>Email</label>
							<input type="email" class="form-control" placeholder="Email" required v-model="email" >
						</div>
						<div class="form-group  mt-3">
							<label>Contraseña</label>
							<input type="password" class="form-control" placeholder="Contraseña" required v-model="password">
						</div>

						<div class="alert alert-danger" v-if="loginError">
							Datos de acceso incorrectos
						</div>
						<div class="form-group mt-3 text-right">
							<button class="btn btn-primary btn-block" type="submit" :disabled="loginIn" >
								<span v-if="loginIn">Ingresando...</span>
								<span v-if="!loginIn">Ingresar</span>
							</button>
						</div>
						<hr>
						<!-- <p class="text-center"><small>Si tienes problemas para ingresar a tu cuenta, ponete en contacto con nosotros.</small></p> -->
					</div>
				</div>
				
			</form>
		</div>
	</div>
</div>
</template>

<script>
import axios from 'axios';
import { onLogin } from '../vue-apollo';
import { mapMutations } from 'vuex'


export default {
    name: 'Login',
    data() {
        return {
            email: '',
            password: '',
            loginError:false,
            loginIn:false,
        }
    },
    beforeMount(){
        // this.logout();
    },
    methods: {
		...mapMutations(['authSuccess','logout']),
        login() {
            this.loginError=false;
            if( !this.loginIn && this.email !='' && this.password!='' ){
                this.loginIn = true;
                axios.post('/auth/user/login', { email: this.email, password: this.password, is_admin: true })
                .then(request => {
                    let access_token = request.data.access_token;
                    let logged_user = request.data.user;
                    onLogin(this.$apollo.provider.defaultClient, access_token, logged_user).then(() => { 
						console.log('asds')
                        this.authSuccess({token:access_token, loggedUser: logged_user});
                        this.loginIn = false;
                        this.$router.push('/');
                    });				
                })
                .catch(() => 
                {
                    this.loginError=true;
                    this.loginIn = false;
                })
            }
		},
    }
}
</script>

<style scoped>
.login-page{
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: calc(100vh - 120px);
}
.logo{
	margin: 0px auto;
	display: block;
}
.login{
	text-align: left;
	background-color: #fff;
	max-width: 300px;
	padding: 16px;
}
h3{
	font-weight: 400;
}


</style>
